module.exports = __webpack_public_path__ + "static/media/undraw_Hello_qnas.ce4c0c0c.svg";